import {createContext} from 'react'

/**
 * A React context for sharing the `focused` state of the editor.
 */

export const FocusedContext = createContext(false)
